import lodash from 'lodash';
import {END_POINT} from "./constant";

const concatTeam = (data) => {
    let arr = [];
    lodash.mapValues(data, (v) => {
        v.forEach(element => {
            arr.push(element)
        })
    })
    return arr;
}
const generateCodeInning = (data,  lastDigit = '0') => {
    let string = "";
    lodash.mapValues(data, function (v) {
        if(v.length === 0) string += '000';
        v.forEach(element => {
            if(element.check === true){
                string += '1'
            }else {
                string += '0'
            }
        });
    });
    return string+lastDigit;
};

const buildKey = (data) => {
    return {
        team_ids: concatTeam(data[END_POINT.teamCondition]['team']),
        oppnent_team_ids: concatTeam(data[END_POINT.teamCondition]['oppTeam']),
        player_ids: lodash.map(data[END_POINT.playerCondition]['player'], 'id'),
        oppnent_player_ids: lodash.map(data[END_POINT.playerCondition]['oppPlayer'], 'id')
    }
}
const buildPeriod = (data) => {
    return {
        from_year: data[END_POINT.selectPeriod]['year']['startYear'],
        to_year: data[END_POINT.selectPeriod]['year']['endYear'],
        is_ever: data[END_POINT.selectPeriod]['allYear'] ? 1 : null,
        months: data[END_POINT.selectPeriod]['monthCheck'],
        base_on_allstars_game: data[END_POINT.selectPeriod]['checkAllStar'],
        date: {
            from: data[END_POINT.selectPeriod]['date']['startDate'],
            to: data[END_POINT.selectPeriod]['date']['endDate'],
        }
    }
}
const buildCondition = (data) => {
    return {
        reach_ruler_turn: data[END_POINT.targetCondition]['ruleAtBat'],
        pa: data[END_POINT.targetCondition]['atBat'],
        ab: data[END_POINT.targetCondition]['overBat'],
        np: data[END_POINT.targetCondition]['moreThanAPick'],
        oppnent_lr_ids: data[END_POINT.leftRightBat],
        course: {
            hl_ids: data[END_POINT.pitchingCourse]['hlIds'],
            lr_ids: data[END_POINT.pitchingCourse]['lrIds'],
            zone_ids: data[END_POINT.pitchingCourse]['zoneIds']
        },
        pitch: {
            speed: {
                from: data[END_POINT.ballSpeed]['min'],
                to: data[END_POINT.ballSpeed]['max'],
            },
            type_ids: lodash.compact(lodash.concat(data[END_POINT.pitchType]['changingSphere'], data[END_POINT.pitchType]['straight']))
        },
        bbs_ids: data[END_POINT.hittingProperty],
        scene: {
            count_ids: lodash.concat(data[END_POINT.count]['oneStrike'], data[END_POINT.count]['twoStrike'], data[END_POINT.count]['threeStrike']),
            runner_ids: lodash.concat(data[END_POINT.runner]['none'] !== null ? data[END_POINT.runner]['none'] : [], data[END_POINT.runner]['available']),
            scoring_position_ids: data[END_POINT.scoringRunner],
            score_diff: {
                diff_ids: data[END_POINT.pointDifference]['diffIds'],
                score: data[END_POINT.pointDifference]['score'],
                uplow: data[END_POINT.pointDifference]['uplow'],
            },
            innings: generateCodeInning(data[END_POINT.inning]),
            top_of_inning_ids: data[END_POINT.inningTopBatter],
        },
        batting_order_ids: data[END_POINT.battingOrder]
    }
}
function buildSearch(data) {
    if(data.type === 'pitchers')
    return {
        column_group_ids: [data[END_POINT.columnGroup]],
        game_category_ids : lodash.compact(lodash.concat(data[END_POINT.categorySection]['regularSeason'], data[END_POINT.categorySection]['postSeason'])),
        keys: buildKey(data),
        period: buildPeriod(data),
        conditions: buildCondition(data),
        pitching_order_ids: data[END_POINT.starterRelief]
    };
    return {
        column_group_ids: [data[END_POINT.columnGroup]],
        game_category_ids : lodash.compact(lodash.concat(data[END_POINT.categorySection]['regularSeason'], data[END_POINT.categorySection]['postSeason'])),
        keys: buildKey(data),
        period: buildPeriod(data),
        conditions: buildCondition(data),
        bbd: {
            "3div_ids" : data[END_POINT.hittingDirection]['3div'],
            "5div_ids" : data[END_POINT.hittingDirection]['5div'],
        },
        pa_of_game_ids: data[END_POINT.atBat],
        np_of_pa_ids: data[END_POINT.numberOfPitcherAtBat],
        position_ids: data[END_POINT.defensivePosition]
    }

}

export default buildSearch;
